'use client';
import { createContext, type PropsWithChildren, useContext } from 'react';
import { showErrorToaster } from '@/utils/toasters';

type AppStateValue = {
  onApiError: (err: unknown, message: string) => void;
};

const AppStateContext = createContext<AppStateValue | null>(null);

export default function AppStateProvider({ children }: PropsWithChildren) {
  const handleApiError = (err: unknown, message: string) => {
    showErrorToaster(message);
    throw err;
  };

  const contextValue = { onApiError: handleApiError };

  return (
    <AppStateContext.Provider value={contextValue}>
      {children}
    </AppStateContext.Provider>
  );
}

export function useAppState() {
  const context = useContext(AppStateContext);
  if (!context) {
    throw Error('useAppState must be used within the AppStateProvider');
  }
  return context;
}
